import { Compass } from "lucide-react";
import type { ReactNode } from "react";

import { Card } from "@/components/ui/Card";

import "./beheer.css";

/**
 * "Dit scherm wordt nog gebouwd" (ontwerp 28-10-2026, scherm 36): een kaart
 * met het kompas, de naam, waar het scherm over gaat en wat ervoor nodig is,
 * en rechts de weg terug. Op de placeholder zelf en als voorbeeld bovenaan het
 * overzicht "Nog te bouwen".
 */
export function TodoNotice({
  title,
  children,
  actions,
}: {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <Card className="atl-todo">
      <div className="atl-todo__body">
        <span className="atl-todo__icon" aria-hidden>
          <Compass size={26} strokeWidth={1.75} />
        </span>
        <div className="atl-todo__text">
          <h2 className="atl-todo__title">{title} · dit scherm wordt nog gebouwd</h2>
          <div className="atl-todo__description">{children}</div>
        </div>
        {actions && <div className="atl-todo__actions">{actions}</div>}
      </div>
    </Card>
  );
}
